// @ts-nocheck
import { content } from "./content";
import { AddressResult } from "../models";

export const isQuerySearchable = (query: string = ""): boolean =>
  !!query && !!query.match(/[a-z]{3}/i);

export const isManualEntryOption = (option?: AddressResult): boolean =>
  option && option.label === content.manualEntry;
